import { createAction, props } from '@ngrx/store';
import { UserModel } from '../../front/models/user.modal';

export namespace AuthActions {
  export const setCurrentUserProfile 
    = createAction(
      '[User] set profile',
      props<{ user: UserModel }>(),
    );
}